export const initialAccounts = [];

export const initialCards = [];

export const initialCategories = [
  // ── RECEITAS ─────────────────────────────────────────────────────────────
  { id: 'sal',      name: 'Salário',       type: 'income',  icon: 'fa-building-columns', color: '#1d9e75',
    subcategories: ['Salário Mensal', 'Pró-labore', '13º Salário', 'Férias', 'Hora Extra', 'Adiantamento'] },

  { id: 'free',     name: 'Freelance',     type: 'income',  icon: 'fa-laptop',           color: '#378ADD',
    subcategories: ['Projeto', 'Consultoria', 'Serviço Avulso', 'Comissão'] },

  { id: 'inv',      name: 'Investimentos', type: 'income',  icon: 'fa-chart-line',       color: '#c9a227',
    subcategories: ['Dividendos', 'Rendimentos CDB/LCI/LCA', 'FIIs', 'Ações', 'Poupança', 'Criptomoedas'] },

  { id: 'bonus',    name: 'Bônus',         type: 'income',  icon: 'fa-gift',             color: '#3B6D11',
    subcategories: ['Bônus', 'Premiação', 'Participação nos Lucros', 'Restituição IR'] },

  { id: 'other-in', name: 'Outros',        type: 'income',  icon: 'fa-circle-plus',      color: '#888780',
    subcategories: ['Aluguel Recebido', 'Reembolso', 'Pensão/Mesada', 'Doação Recebida', 'Venda de Bens'] },

  // ── DESPESAS ─────────────────────────────────────────────────────────────
  { id: 'moradia',  name: 'Moradia',       type: 'expense', icon: 'fa-house',            color: '#e24b4a',
    subcategories: ['Aluguel', 'Condomínio', 'IPTU', 'Energia Elétrica', 'Água/Saneamento', 'Gás', 'Internet/TV/Telefone', 'Manutenção/Reforma'] },

  { id: 'alim',     name: 'Alimentação',   type: 'expense', icon: 'fa-utensils',         color: '#c9a227',
    subcategories: ['Supermercado', 'Restaurante/Lanchonete', 'Delivery', 'Padaria/Confeitaria', 'Açougue/Peixaria', 'Hortifruti'] },

  { id: 'transp',   name: 'Transporte',    type: 'expense', icon: 'fa-car',              color: '#185FA5',
    subcategories: ['Combustível', 'Uber/99/Táxi', 'Ônibus/Metrô', 'Estacionamento', 'Pedágio', 'Manutenção Veículo', 'IPVA/Seguro Auto'] },

  { id: 'saude',    name: 'Saúde',         type: 'expense', icon: 'fa-heart-pulse',      color: '#993556',
    subcategories: ['Farmácia', 'Consulta Médica', 'Exames/Laboratório', 'Plano de Saúde', 'Dentista', 'Psicólogo', 'Academia/Esportes'] },

  { id: 'educ',     name: 'Educação',      type: 'expense', icon: 'fa-graduation-cap',   color: '#3B6D11',
    subcategories: ['Escola/Faculdade', 'Curso/Capacitação', 'Livros/Material', 'Material Escolar'] },

  { id: 'lazer',    name: 'Lazer',         type: 'expense', icon: 'fa-gamepad',          color: '#854F0B',
    subcategories: ['Viagem/Hospedagem', 'Cinema/Teatro/Shows', 'Streaming (Netflix/Spotify)', 'Jogos', 'Hobby/Esporte', 'Bares/Balada'] },

  { id: 'contas',   name: 'Contas',        type: 'expense', icon: 'fa-file-invoice',     color: '#185FA5',
    subcategories: ['Tarifa Bancária', 'Seguro de Vida', 'Seguro Residencial', 'IOF', 'Imposto/Taxa', 'Capitalização'] },

  { id: 'vest',     name: 'Vestuário',     type: 'expense', icon: 'fa-shirt',            color: '#533F91',
    subcategories: ['Roupas', 'Calçados', 'Acessórios', 'Bolsas', 'Roupas Esportivas'] },

  { id: 'pets',     name: 'Pets',          type: 'expense', icon: 'fa-paw',              color: '#0F6E56',
    subcategories: ['Alimentação Pet', 'Veterinário', 'Banho/Tosa', 'Medicamentos Pet', 'Produtos/Acessórios Pet'] },

  { id: 'cartao',   name: 'Cartão crédito', type: 'expense', icon: 'fa-credit-card',    color: '#A32D2D',
    subcategories: ['Fatura Cartão', 'Anuidade', 'Juros/Encargos'] },

  { id: 'other-ex', name: 'Outros',        type: 'expense', icon: 'fa-circle-minus',    color: '#888780',
    subcategories: ['Presente/Doação', 'Multa/Infração', 'Serviço Doméstico', 'Beleza/Estética'] },
];

export const initialTransactions = [];

export const initialGoals = [];

export const initialBudgets = [];
